import { cn } from "@/lib/utils";

type LoaderProps = {
  className?: string;
  spinnerClassName?: string;
};

export function Loader({ className, spinnerClassName }: LoaderProps) {
  return (
    <div className={cn("flex items-center justify-center py-10", className)}>
      <div
        className={cn("h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-foreground", spinnerClassName)}
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}
